module.exports = __webpack_public_path__ + "static/section-four-4147e9a0e8f244c9769c9c39c2d6efbc.png";